<template>
    <div class="accordion accordion-ho mt-2">
        <div class="card">
            <div class="card-header">
                <a href="javascript:void(0);" class="card-title " v-on:click="show_childs"
                   :aria-expanded="is_active ? 'true' : 'false'"
                   :class="{'colapsed' : is_active,'collapsed' : !is_active}">
                    <span class="position-absolute override" v-if="item.has_override">
                        <i class="fal fa-sync fs-xl" ></i>
                    </span>


                    {{item.title}} ({{__t('P.MIN')}} {{item.min_qual}} - {{__t('P.MAX')}} {{item.max_qual}})

                    <span class="position-absolute remove" v-on:click.stop.prevent="remove_item(item)" >
                          <span  class="btn btn-danger btn-sm btn-icon waves-effect waves-themed">
                              <i class="fal fa-times"></i>
                          </span>
                    </span>

                    <span class="ml-auto mr-5 pr-2" >
                        <span class="collapsed-reveal">
                            <i class="fal fa-chevron-up fs-xl"></i>
                        </span>
                        <span class="collapsed-hidden">
                            <i class="fal fa-chevron-down fs-xl"></i>
                        </span>
                    </span>
                </a>
            </div>
            <div class="collapse"  v-bind:class="{'show' : is_active }" style="">
                <div class="card-body" v-if="childrens.length > 0">

                    <div class="d-flex flex-row align-items-center p-2" v-for="child in this.childrens">
                        <div class="icon-stack display-3 flex-shrink-0">
                            <i class="fal fa-circle icon-stack-3x opacity-100 color-primary-400"></i>
                            <i class="fas fa-address-book icon-stack-1x opacity-100 color-primary-500"></i>
                        </div>
                        <div class="ml-3">
                            <strong>
                                {{child.name}}
                            </strong>
                            <br>
                            {{new Intl.NumberFormat('ru-RU').format(parseFloat(child.price))}}
                            <span class="woocommerce-Price-currencySymbol  fs-sm"> ₴</span>
                        </div>

                        <div class="children_publish icon-stack display-3 flex-shrink-0 ml-auto">
                            <span v-if="child.published">
                                <b-form-checkbox
                                    @input="change(child)"
                                    v-model="child.published_in"
                                    name="check-button"
                                    class="mt-3" switch>
                                </b-form-checkbox>
                            </span>
                            <span v-else>
                                -
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "product_group_new",
        props : {
            item : {
                type:Object
            }
        },
        data() {
            return {
                is_active : false,
            }
        },

        methods : {
            show_childs() {
                this.is_active = !this.is_active
            },

            async change (child) {
                api.patch('/internal/v1/catalog/products/modifiers/' + child.record_id + "/state")
                    .then(({data}) => {

                    }).catch(({response}) => {
                        EventBus.$emit('show_toast', {
                            err: response.data.message, type: "danger",
                            title: response.data.status,
                        })
                    });
            },

            remove_item(group){
                this.$emit("remove_group", group.id);
            }
        },

        computed : {
            childrens () {
                if(this.item.hasOwnProperty("childrens")) {
                    return this.item.childrens;
                }

                return [];
            }
        }
    }
</script>

<style scoped>
    .override {
        right: 80px;
    }
    .remove {
        right: 10px;
    }
</style>
